module.exports = __webpack_public_path__ + "static/media/icon_1.873ae230.svg";